export const header1MenuSelector = ({
  layoutReducer: { header1MenuOptions = {} } = {},
}) => header1MenuOptions;
